import { render, staticRenderFns } from "./UpdatePopup.vue?vue&type=template&id=71d8206c&scoped=true&"
import script from "./UpdatePopup.vue?vue&type=script&lang=js&"
export * from "./UpdatePopup.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePopup.vue?vue&type=style&index=0&id=71d8206c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8206c",
  null
  
)

export default component.exports